<template>
    <div v-if="usage">
        <b-form-group>
            <h5>Account:</h5> {{ usage.account.total_price / 100 }} {{ currency }} <span v-if="usage.account.volume >= 12"> {{ $t('annually') }} </span>
        </b-form-group>

        <b-form-group>
            <template #label>
                <h5>Workspaces</h5>
            </template>

            <ul>
                <li v-for="workspace in usage.workspaces" :key="workspace.name"> <span class="gray-text">{{ workspace.name }}</span> - {{ workspace.total_price / 100 }}  {{ currency }}</li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Components</h5>
            </template>

            <span class="gray-text" v-if="usage.components.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="component in usage.components" :key="component.name"> <span class="gray-text">{{ component.name }}</span> - {{ component.total_price / 100 }}  {{ currency }}
                    <ul>
                        <li class="gray-text">Volume: {{component.volume}} {{ component.unit }}</li>
                    </ul>
                </li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Thunders</h5>
            </template>

            <span class="gray-text" v-if="usage.thunders.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="thunder in usage.thunders" :key="thunder.name"> <span class="gray-text">{{ thunder.name }}</span> - {{ thunder.total_price / 100 }}  {{ currency }}
                    <ul>
                        <li class="gray-text">Volume: {{thunder.volume}} {{ thunder.unit }}</li>
                    </ul>
                </li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Platform apps</h5>
            </template>

            <span class="gray-text" v-if="usage.platform_apps.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="app in usage.platform_apps" :key="app.name"> <span class="gray-text">{{ app.name }}</span> - {{ app.total_price / 100 }}  {{ currency }}</li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Public apps</h5>
            </template>

            <span class="gray-text" v-if="usage.public_apps.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="app in usage.public_apps" :key="app.name"> <span class="gray-text">{{ app.name }}</span> - {{ app.total_price / 100 }}  {{ currency }}</li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Sparks</h5>
            </template>

            <span class="gray-text" v-if="usage.sparks.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="spark in usage.sparks" :key="spark.name"> <span class="gray-text">{{ spark.name }}</span> - {{ spark.total_price / 100000 }}  {{ currency }}
                    <ul>
                        <li class="gray-text">Volume: {{spark.volume}} {{spark.unit}}</li>
                    </ul>
                </li>
            </ul>
        </b-form-group>
        <b-form-group>
            <template #label>
                <h5>Templates</h5>
            </template>

            <span class="gray-text" v-if="usage.templates.length < 1"> {{ $t('seemsLikeThereIsNothingHere') }} </span>
            <ul>
                <li v-for="template in usage.templates" :key="template.name"> <span class="gray-text">{{ template.name }}</span> - {{ template.total_price / 100 }}  {{ currency }}</li>
            </ul>
        </b-form-group>
        
    </div>

    <b-skeleton height="250px" animation="throb" v-else></b-skeleton>
</template>

<style scoped>
.gray-text {
    color: #ccc;
}
</style>

<script>
import Price from '@/plugins/protokol/lib/Price'

export default {
    props: {
        project: {
            type: Object
        }
    },
    data: function() {
        return {
            usage: null
        }
    },

    computed: {
        currency() {
            const { billing_address = {} } = this.$store.getters.getUser.settings
            const { country } = billing_address  || {}

            const p = new Price(
                country,
                this.$store.getters.getLocale,
            )

            return p.getCurrency()
        },
    },

    mounted() {
        this.$http.get(`/v1/system/usage/${this.currency}`).then(resp => {
            this.usage = resp.data
        }).catch(err => {
            if (err.response) {
                // we failed to fetch some of the usages still show the data
                if (err.response.status == 424) {
                    this.usage = err.response.data

                    this.$bvToast.toast(this.$t('failedToGenerateSomeOfTheUsages'), {
                        title: this.$t('warning'),
                        variant: 'warning'
                    })
                }

                return
            }

            this.$debugLog(err)

            this.$bvToast.toast(this.$t('unexpectedError'), {
                title: this.$t('error'),
                variant: 'danger'
            })
        })
    }
}
</script>